{
	"page": {
		"title": "Sports",
		"intro": "The programme of each games. A <strong>sport</strong> (Aquatics, Athletics…) holds <strong>disciplines</strong> (Swimming, Diving…), and each discipline holds the medal events. An inactive sport stays on record but leaves the pickers and OVR's navigation.",
		"addSport": "Add sport",
		"building": "This page is being built.",
		"count_one": "{{n}} sport",
		"count_other": "{{n}} sports"
	},
	"games": {
		"label": "Games",
		"placeholder": "Pick a games",
		"loadFailed": "Couldn't load the games",
		"para": "Para"
	},
	"filters": {
		"gamesLabel": "Games",
		"statusLabel": "Status",
		"active": "Active",
		"inactive": "Inactive",
		"searchPlaceholder": "Search sports by code or name",
		"disciplineSearchPlaceholder": "Search disciplines by code or name"
	},
	"table": {
		"code": "Code",
		"name": "Name",
		"translations": "Translations",
		"translationsTitle": "Languages this name is translated into",
		"sortOrder": "Order",
		"status": "Status",
		"active": "Active",
		"inactive": "Inactive",
		"disciplines": "Disciplines",
		"disciplinesTitle": "View the disciplines of this sport",
		"events": "Events",
		"eventsTitle": "Events across this sport's disciplines",
		"created": "Created",
		"updated": "Updated",
		"viewLabel": "View disciplines of {{name}}",
		"editLabel": "Edit {{name}}",
		"deleteLabel": "Delete {{name}}"
	},
	"pagination": {
		"summary_one": "{{from}}–{{to}} of {{total}} sport",
		"summary_other": "{{from}}–{{to}} of {{total}} sports",
		"empty": "No sports",
		"disciplineSummary_one": "{{from}}–{{to}} of {{total}} discipline",
		"disciplineSummary_other": "{{from}}–{{to}} of {{total}} disciplines",
		"disciplineEmpty": "No disciplines"
	},
	"empty": {
		"filteredTitle": "No sports match these filters",
		"filteredDescription": "Try a broader search, or clear the filters.",
		"noneTitle": "No sports in this games yet",
		"noneDescription": "Add the sports on the programme.",
		"noGamesTitle": "No games set up",
		"noGamesDescription": "Sports belong to a games. Ask a super admin to set one up first.",
		"disciplineFilteredTitle": "No disciplines match this search",
		"disciplineFilteredDescription": "Try a broader search, or clear it.",
		"disciplineNoneTitle": "No disciplines yet",
		"disciplineNoneDescription": "Add the disciplines of {{name}}.",
		"clearFilters": "Clear filters"
	},
	"detail": {
		"backToSports": "Sports",
		"meta": "{{games}} · order {{order}}",
		"inactive": "Inactive",
		"addDiscipline": "Add discipline",
		"loadFailedTitle": "Couldn't load this sport",
		"count_one": "{{n}} discipline",
		"count_other": "{{n}} disciplines",
		"subtitle": "Sport"
	},
	"disciplineTable": {
		"code": "Code",
		"name": "Name",
		"translations": "Translations",
		"sortOrder": "Order",
		"status": "Status",
		"active": "Active",
		"inactive": "Inactive",
		"events": "Events",
		"eventsTitle": "View this discipline's events",
		"created": "Created",
		"updated": "Updated",
		"editLabel": "Edit {{name}}",
		"deleteLabel": "Delete {{name}}"
	},
	"form": {
		"addTitle": "Add sport",
		"addDescription": "A new sport in {{games}}. Its code is what OVR and the result feeds key on.",
		"addSubmit": "Add sport",
		"saveChanges": "Save changes",
		"editInUse_one": "{{count}} event sits under this sport — a code change shows everywhere the sport is listed.",
		"editInUse_other": "{{count}} events sit under this sport — a code change shows everywhere the sport is listed.",
		"editEmpty": "No events under this sport yet.",
		"section": {
			"identity": "Identity",
			"identityHint": "How the sport reads on lists, schedules and results.",
			"translations": "Translations",
			"translationsHint": "The name in each GMS language. Leave a box empty to show the English name.",
			"display": "Display",
			"displayHint": "Where the sport sits in lists, and whether pickers offer it."
		},
		"field": {
			"name": "Name",
			"nameHint": "The English name — the master every translation follows.",
			"code": "Code",
			"codeHint": "Letters, numbers, - and _ only, like AQ or ATH. Stored in capitals.",
			"iconUrl": "Icon URL",
			"iconUrlHint": "A web address starting with https://. Leave empty for no icon.",
			"sortOrder": "Sort order",
			"sortOrderHint": "Lists order by this — the programme is not alphabetical.",
			"isActive": "Active",
			"isActiveHint": "An inactive sport stays on record but leaves the pickers and OVR's navigation."
		},
		"placeholder": {
			"name": "Aquatics",
			"code": "AQ",
			"iconUrl": "https://"
		}
	},
	"disciplineForm": {
		"addTitle": "Add discipline under {{code}} — {{name}}",
		"addDescription": "A discipline of this sport. Its events are added on the Events page.",
		"addSubmit": "Add discipline",
		"saveChanges": "Save changes",
		"editInUse_one": "{{count}} event sits under this discipline — a change shows on it immediately.",
		"editInUse_other": "{{count}} events sit under this discipline — a change shows on them immediately.",
		"editEmpty": "No events under this discipline yet.",
		"section": {
			"identity": "Identity",
			"identityHint": "How the discipline reads on lists, schedules and results.",
			"translations": "Translations",
			"translationsHint": "The name in each GMS language. Leave a box empty to show the English name.",
			"display": "Display",
			"displayHint": "Where the discipline sits in lists, and whether pickers offer it."
		},
		"field": {
			"name": "Name",
			"nameHint": "The English name — the master every translation follows.",
			"code": "Code",
			"codeHint": "Letters, numbers, - and _ only, like SWM. Stored in capitals.",
			"sortOrder": "Sort order",
			"sortOrderHint": "Lists order by this, within the sport.",
			"isActive": "Active",
			"isActiveHint": "An inactive discipline stays on record but leaves the pickers and OVR's navigation.",
			"sideScheme": "Sides",
			"sideSchemeHint": "What OVR calls the two sides of a match. Most net and racket sports have none: the order decides (1 on top)."
		},
		"placeholder": {
			"name": "Swimming",
			"code": "SWM"
		},
		"sideScheme": {
			"SEQUENCE": "No names — order 1 on top, 2 below",
			"HOME_AWAY": "Home / Away",
			"RED_BLUE": "Red / Blue",
			"WHITE_BLUE": "White / Blue",
			"AKA_AO": "Aka / Ao"
		}
	},
	"delete": {
		"title": "Delete sport",
		"description": "Delete <strong>{{name}}</strong>? This only works while nothing references it — disciplines, para classes or accreditation cards. To take it off the programme, mark it inactive instead.",
		"confirm": "Delete sport",
		"deleted": "{{name}} deleted.",
		"failed": "Couldn't delete sport"
	},
	"disciplineDelete": {
		"title": "Delete discipline",
		"description": "Delete <strong>{{name}}</strong>? This only works while it has no events. To take it off the programme, mark it inactive instead.",
		"confirm": "Delete discipline",
		"deleted": "{{name}} deleted.",
		"failed": "Couldn't delete discipline"
	},
	"toast": {
		"added": "{{name}} added.",
		"updated": "{{name}} updated.",
		"addFailed": "Couldn't add sport",
		"updateFailed": "Couldn't update sport",
		"disciplineAdded": "{{name}} added.",
		"disciplineUpdated": "{{name}} updated.",
		"disciplineAddFailed": "Couldn't add discipline",
		"disciplineUpdateFailed": "Couldn't update discipline"
	},
	"errors": {
		"codeTaken": "A sport with that code already exists in this games.",
		"nameTaken": "A sport with that name already exists in this games.",
		"gamesMissing": "That games no longer exists.",
		"inUse": "This sport is still referenced by disciplines, para classes or accreditation cards. Remove those first, or mark it inactive.",
		"disciplineCodeTaken": "A discipline with that code already exists in this sport.",
		"disciplineNameTaken": "A discipline with that name already exists in this sport.",
		"sportMissing": "That sport no longer exists.",
		"disciplineInUse": "This discipline still has events. Remove those first, or mark it inactive.",
		"invalidValue": "Invalid value"
	},
	"sort": {
		"programme": "Programme order",
		"programmeDesc": "Programme order, reversed"
	},
	"stats": {
		"total": "Sports",
		"matching": "matching the filters",
		"activeSports": "Active sports",
		"activeDisciplines": "Active disciplines",
		"activeEvents": "Active events",
		"disciplines": "Disciplines",
		"events": "Events"
	}
}
